// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Q23jl","description":"modal_description__Yyt2r"};